import identityProviders from '@/constant/identityProviders'

export const LIVE_CERTIFICATE_ATTRIBUTE = 'liveCertificate'
export const CERTIFICATE_SETTINGS_TAB = { key: 'certificate', label: 'Certificate' }
export const LIVE_CERTIFICATES_FLAG = 'AHA-49363-live-certificates'
export const CERTIFICATE_SENTRY_CONTEXT = {
  featureFlag: LIVE_CERTIFICATES_FLAG,
  featureName: 'live-certificates',
  taskId: 'SEPA-15',
}

export const LIVE_CERTIFICATES_RUN_SENTRY_CONTEXT = { ...CERTIFICATE_SENTRY_CONTEXT, taskId: 'CORE-56' }

export const CERTIFICATE_CHOICE_SENTRY_CONTEXT = { ...CERTIFICATE_SENTRY_CONTEXT, taskId: 'SEPA-14' }

export const STANDARD_CERTIFICATE_TEMPLATE_ID = 'standard'
export const NO_CERTIFICATE_TEMPLATE_ID = 'off'
export const NEW_CERTIFICATE_MANAGE_PATH = '/apps/addons/aha-manage/certificates/new'

export const DEFAULT_CERTIFICATE_RULES = {
  minAnsweredPercent: null,
  minQuizScorePercent: null,
}

export const DEFAULT_RULE_PERCENT = 50

export const clampPercent = (value) => {
  const parsed = parseInt(value, 10)
  if (Number.isNaN(parsed)) return DEFAULT_RULE_PERCENT
  return Math.min(100, Math.max(0, parsed))
}

export const LOGIN_TO_GET_CERTIFICATE_MESSAGE_KEY = 'loginToGetCertificate'

export const isLiveCertificateIssuing = (settings) => !!settings?.enabled
  && settings.certificateTemplateId !== NO_CERTIFICATE_TEMPLATE_ID

export const isWhiteLabelOrSkoletubeUser = (user) => !!user &&
  (user.plan === 'white-label' || user.identifyProvider === identityProviders.SKOLETUBE)

export const CERTIFICATE_REQUIRES_LOGIN_CODE = 'certificate_requires_login'

export const isCertificateRequiresLoginError = (error) => error?.body?.code === CERTIFICATE_REQUIRES_LOGIN_CODE
